import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
  width: 3.5rem;
  height: 3.5rem;
  flex-shrink: 0;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export { Wrapper, Image };
